import { render, staticRenderFns } from "./ProtocolFindingsForm.vue?vue&type=template&id=3944f06a"
import script from "./ProtocolFindingsForm.vue?vue&type=script&lang=js"
export * from "./ProtocolFindingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports